import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import GiftCardInformationsView from "@components/views/GiftCards/GiftCardInformations";

const GiftCardInformations = ({ amount }) => (
  <GiftCardInformationsView
    amount={amount}
    standardGiftCard
  />
);

export async function getServerSideProps({ locale, query }) {
  const { amount } = query;

  if (amount < 25) {
    return {
      redirect: {
        destination: "/buy_gift_cards",
        permanent: false,
      },
    };
  }

  return {
    props: {
      amount,
      headerBehaviors: { noFooter: true, noNavbar: true },
      ...(await serverSideTranslations(locale, ["common", "gift_cards", "stripe"])),
    },
  };
}

GiftCardInformations.requireAuth = false;

export default GiftCardInformations;
